export default __webpack_public_path__ + "static/media/directoryv3.317a7ab4.jpg";